import { API } from "@brg/api"

const cardsEndpoints: any = {
    develop: 'https://api.burgdev.ru/cards',
    staging: 'https://api.burgstg.ru/cards',
    production: 'https://api.mediiia.ru/cards',
}

export const createProductByProject = (projectId: string) => {
    const windowRef: any = window.open('', '_blank')
    const asyncFunc = async () => {
        try {
        const mode = process.env.REACT_APP_API_CONNECTION_MODE
        const url = `${cardsEndpoints[mode || 'production']}/api/Card/AddProductByProject`
        const params = {
            projectId: projectId,
            categoryType: 3
        }
        const createProductRequest = await API.fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(params)
        })
        const createProductResponse = await createProductRequest.json()
        const {cardId} = createProductResponse || {}
        const newCardUrl = `${process.env.REACT_APP_URL_GALLERY}/card/${cardId}?shouldForcedLogin=true&saveLoginUrl=true`
        // window.open(newCardUrl, '_blank')
        return newCardUrl

        } catch (err) {
            return err
        }
    }
    asyncFunc().then((res: any) => windowRef.location = res)
}import { API } from "@brg/api"

const cardsEndpoints: any = {
    develop: 'https://api.burgdev.ru/cards',
    staging: 'https://api.burgstg.ru/cards',
    production: 'https://api.mediiia.ru/cards',
}

export const createProductByProject = (projectId: string) => {
    const windowRef: any = window.open('', '_blank')
    const asyncFunc = async () => {
        try {
        const mode = process.env.REACT_APP_API_CONNECTION_MODE
        const url = `${cardsEndpoints[mode || 'production']}/api/Card/AddProductByProject`
        const params = {
            projectId: projectId,
            categoryType: 3
        }
        const createProductRequest = await API.fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8'
            },
            body: JSON.stringify(params)
        })
        const createProductResponse = await createProductRequest.json()
        const {cardId} = createProductResponse || {}
        const newCardUrl = `${process.env.REACT_APP_URL_GALLERY}/card/${cardId}?shouldForcedLogin=true&saveLoginUrl=true`
        // window.open(newCardUrl, '_blank')
        return newCardUrl

        } catch (err) {
            return err
        }
    }
    asyncFunc().then((res: any) => windowRef.location = res)
}